import { SCENE_INTERACTION } from "../../../constants/scene.js";
import { ANT_MEDIA_SERVER_BAGELSS_EVENTS, states } from "../constants.js";
import { WebRTCAdaptor } from "../media-server-external/webrtc_adaptor.js";
import { CONTROLLERS } from "./UnifiedAntMediaController.js";
import { FEATURE_NAMES, UNLIMITED } from "../../MVC/rolesHelper";
import { TourModeTimer } from "../../engine/TourModeWindow";

export class AntMediaControllerScreen {
  constructor(model, pc_config, sdpConstraints, token, roomNameBox, videoMode, myVideoElement, successCallback, errorCallback, controller) {
    this.controller = controller;
    this.successCallback = successCallback;
    this.errorCallback = errorCallback;
    this.model = model;
    this.pc_config = pc_config;
    this.sdpConstraints = sdpConstraints;
    this.token = token;
    this.roomNameBox = roomNameBox;
    this.videoMode = videoMode;
    this.myVideoElement = myVideoElement;
    this.playOnly = false; // or set based on your logic
    this.isCameraOff = false;
    this.insideRoom = false;
    this.publishStreamId = null;
    this.webRTCAdaptor = null;
    this.streamsList = [];
    this.roomTimerId = null;
    this.dominantSpeakerFinderId = null;
    this.isDataChannelOpen = false;
    this.mutedAlertPresent = false;
    this.canvasInfo = {}; // Define the structure based on your needs
    this.forceStopTourTimer;
    this.cancelStopTourCountdown;

    this.state = states.NOT_IN_ROOM;

    this.mediaConstraints = this.displayCaptureConstraints();

    this.sdpConstraints = {
      OfferToReceiveAudio: false,
      OfferToReceiveVideo: false
    };

    this.pc_config = {
      'iceServers': [{
        'urls': 'stun:stun1.l.google.com:19302'
      }]
    };
    this.addListenersForScreenVideoANT();
  }
  displayCaptureConstraints() {
    return {
      video: "screen",
      audio: true,
      displayAudioOnly: true,
      displayMediaConstraints: {
        video: {
          width: { ideal: 1920, max: 1920 },
          height: { ideal: 1080, max: 1080 },
        }
      }
    };
  }

  muteLocalMic = ({ monitor = true } = {}) => {
    this.isMicMuted = true;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.muteLocalMic();
    if (!monitor) {
      this._monitoringMutedMic = false;
      this.webRTCAdaptor.disableAudioLevelWhenMuted();
      return;
    }
    if (this._monitoringMutedMic)
      return;
    this._monitoringMutedMic = true;
    this.webRTCAdaptor.enableAudioLevelWhenMuted();
  }

  unmuteLocalMic = () => {
    this.isMicMuted = false;
    this._monitoringMutedMic = false;
    if (!this.webRTCAdaptor)
      return;
    this.webRTCAdaptor.unmuteLocalMic();
    this.webRTCAdaptor.disableAudioLevelWhenMuted();
  }

  updateBaglessSocketUsers = () => {
    const data = {
      screenShareStreamId: this.publishStreamId,
    }
    this.model.socket.userStartedWebRTCStream(data);
  }
  removeFromChair = () => {
    const data = {
      screenShareStreamId: null,
    }
    this.model.socket.userStartedWebRTCStream(data);
    this.model.killStream($("#screenVideoANT")[0].srcObject);
  }
  leaveRoom = () => {
    // Stop all remote video tracks before leaving
    if (this.streamsList && this.streamsList.length > 0) {
      this.streamsList.forEach((streamId) => {
        const video = document.getElementById("remoteVideo-" + streamId);
        if (video && video.srcObject) {
          video.srcObject.getTracks().forEach(track => track.stop());
          video.srcObject = null;
        }
        this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
      });
      this.streamsList = [];
    }
    
    // Stop local video tracks
    const localVideo = document.getElementById("screenVideoANT");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }
    
    // Leave room and close stream
    this.webRTCAdaptor && this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
    this.closeStream();
  }
  toggleAudio = () => {
    this.controller.applyAudioOwner();
  }

  checkVideoTrackStatus = (streamList) => {
    streamList.forEach((item) => {
      const video = document.getElementById("remoteVideo-" + item);
      if (video != null && !video.srcObject.active) {
        this.webRTCAdaptor.stop(item);
        // this.controller.removeRemoteVideo(item);
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
      if (video === null) {
        if (this.controller.streamIsMine(item))
          return;
        this.webRTCAdaptor.play(item, null, this.roomNameBox);
      }
    });
  }
  ///add listeners for screenVideoANT element
  addListenersForScreenVideoANT() {
    const screenVideoANT = document.getElementById("screenVideoANT");
    screenVideoANT.addEventListener("play", () => {
      if (this.state === states.JOINED_ROOM) {
        this.controller.applyAudioOwner();
        this.publish();
      }
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.SCREEN_SHARE_VIDEO_PLAY_STARTED });
    });
  }


  connect() {
    var self = this;
    return new Promise(function (resolve, reject) {
      const webRTCAdaptor = new WebRTCAdaptor({
        websocket_url: "wss://bagless-media-server.com:5443/WebRTCAppEE/websocket",
        mediaConstraints: self.mediaConstraints,
        peerconnection_config: self.pc_config,
        sdp_constraints: self.sdpConstraints,
        localVideoId: "screenVideoANT",
        isPlayMode: false,
        debug: false,
        dataChannelEnabled: false,
        // bandwidth: 300,
        callback: (info, obj) => {
          if (info === "initialized") {
            resolve(self.webRTCAdaptor);
            self.joinRoom();
          }
          if (info === "leavedFromRoom") {
            self.state = states.NOT_IN_ROOM;
          }
          self.handleCallback(info, obj);
        },
        callbackError: function (error, message) {
          self.handleCallbackError(error, message);
          if (error === "ScreenSharePermissionDenied") {
            reject(error);
            self.model.alert('error', $trans('error-screen-share'), { dataLang: 'error-screen-share' });
            self.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.ERROR_SCREEN_SHARE_PERMISSION_DENIED });
          }
        }
      });
      webRTCAdaptor.onerror = function (err) {
        reject(err);
      };
      self.webRTCAdaptor = webRTCAdaptor;
    });
  }

  joinDesktop() {
    const constraints = this.displayCaptureConstraints();
    this.mediaConstraints = constraints;
    if (this.webRTCAdaptor) {
      this.webRTCAdaptor.mediaConstraints = constraints;
      if (this.webRTCAdaptor.mediaManager) {
        this.webRTCAdaptor.mediaManager.mediaConstraints = constraints;
      }
      this.webRTCAdaptor.switchDesktopCapture();
    }
    this.joinRoom();
  }
  joinCamera(cameraId) {
    this.customCameraId = cameraId;
    this.webRTCAdaptor.switchVideoCameraCapture(this.publishStreamId, cameraId);
    this.isCustomPublish = true;
    this.joinRoom();
  }

  joinRoom() {
    if (this.state === states.JOINED_ROOM)
      return;
    this.publishStreamId = "SCREEN" + this.model.config.userId;
    this.webRTCAdaptor && this.webRTCAdaptor.joinRoom(this.roomNameBox, this.publishStreamId);
  }

  publish() {
    this.publishStreamId = "SCREEN" + this.model.config.userId;
    this.webRTCAdaptor && this.webRTCAdaptor.publish(this.publishStreamId);
  }

  async handleCallback(info, obj) {
    if (info == "leavedFromRoom") {
      // this.model.killStream($("#screenVideoANT")[0].srcObject);
      this.state = states.NOT_IN_ROOM;
      if (this.roomTimerId != null) {
        clearInterval(this.roomTimerId);
        clearInterval(this.dominantSpeakerFinderId);
        this.roomTimerId = null;
      }
    }
    if (info == "publish_started") {
      this.state = states.JOINED_ROOM;
      this.updateBaglessSocketUsers();
      this.model.hideLoading();
      this.controller.applyAudioOwner();

      const checkingFeatureName = this.model.tourMode ? FEATURE_NAMES.TOURS_SCREENSHARE : FEATURE_NAMES.UNLIMITED_SCREENSHARE
      const subscribedFeature = this.model.config?.subscriptionPlan?.plan?.features?.[checkingFeatureName]
      if (subscribedFeature?.value && subscribedFeature?.value !== UNLIMITED) {
        const infoMessage = $trans('error-screen-share-limited') + ' ' + subscribedFeature.value + ' ' + $trans('minutes');
        this.model.info('info', infoMessage, { showTime: 15000 });
        this.model.info('info', $trans('error-screen-share-upgrade-text'), { showTime: 15000 });

        const timeout = subscribedFeature.value * 60 * 1000;
        this.forceStopTourTimer = setTimeout(() => {
          this.model.view._stopScreenShare();
          this.model.dispatchEvent({ type: SCENE_INTERACTION.USER_CLICKED_STOP_SCREEN_SHARE_BUTTON_IN_MEETING_MODE });
          this.model.info('info', 'Your screenshare has ended due to time limit.');
          this.model.info('info', 'Upgrade to continue exploring without time limits!');
        }, timeout);

        if (!this.model.tourMode) {
          $('.tour-mode__timer').show();
          this.cancelStopTourCountdown = TourModeTimer.startCountdown(
            Date.now() + timeout,
            {
              tooltip: $trans('error-screen-share-limited') + ' ' + subscribedFeature.value + ' ' + $trans('minutes'),
              onComplete: () => {
                $('.tour-mode__timer').hide();
              }
            }
          ).finish;
        }
      }
    }

    if (info == "publish_finished") {
      this.forceStopTourTimer && clearTimeout(this.forceStopTourTimer);
      this.cancelStopTourCountdown?.();
      this.state = states.NOT_IN_ROOM;
    }

    if (info == "joinedTheRoom") {
      this.state = states.JOINED_ROOM;
      if (obj.streams != null) {
        obj.streams.forEach((item) => {
          this.webRTCAdaptor.play(item, this.token, this.roomNameBox)
        });

      }
      this.roomTimerId = setInterval(() => {
        if (this.state === states.JOINED_ROOM) {
          // this.webRTCAdaptor && this.webRTCAdaptor.getRoomInfo(this.roomNameBox, this.publishStreamId);
        }
      }, 2000);
      if (this.roomJoinedCallback) {
        this.roomJoinedCallback && this.roomJoinedCallback();
        this.roomJoinedCallback = null;
      }
    }
    else if (info == "roomInformation") {
      this.state = states.JOINED_ROOM;
      // console.log("streamsList", this.streamsList, CONTROLLERS.SCREEN);
      //Checks if any new stream has added, if yes, plays.
      for (let str of obj.streams) {
        if (!this.streamsList.includes(str)) {
          if (!str.includes(this.model.config.userId)) {
            this.webRTCAdaptor.play(str, this.token, this.roomNameBox);
          }
        }
      }
      // Checks if any stream has been removed, if yes, removes the view and stops webrtc connection.
      for (let str of this.streamsList) {
        if (!obj.streams.includes(str)) {
          this.controller.removeRemoteVideo(str);
          this.webRTCAdaptor.stop(str);
        }
      }
      this.streamsList = obj.streams;
      this.checkVideoTrackStatus(this.streamsList)
      // this.controller.checkVideoTrackStatus(this.streamsList);
    }
    // Implement your logic based on the 'info' parameter
    // This function will be invoked on various events from the WebRTCAdaptor
    this.successCallback && this.successCallback(info, obj, CONTROLLERS.SCREEN);
    // You can expand this method to handle different info cases
  }

  handleCallbackError(error, message) {
    // Handle errors from the WebRTCAdaptor
    this.errorCallback && this.errorCallback(error, message);
    if (error === "publishTimeoutError") {
      this.publish();
    }
    if (error === "ScreenSharePermissionDenied") {
      this.leaveRoom();
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.LEAVE_ROOM_SUCCESS_SCREEN_SHARE });
      this.removeFromChair();
    }
    if (error === "NotAllowedError") {
      this.leaveRoom();
      this.model.dispatchEvent({ type: ANT_MEDIA_SERVER_BAGELSS_EVENTS.LEAVE_ROOM_SUCCESS_SCREEN_SHARE });
      this.removeFromChair();
      this.model.showSelfCheckModal();
    }
    console.error("Callback Error:", error, message);
  }

  // Additional methods (e.g., start/stop streams) can be added here
  closeStream() {
    // Stop local video tracks explicitly
    const localVideo = document.getElementById("screenVideoANT");
    if (localVideo && localVideo.srcObject) {
      localVideo.srcObject.getTracks().forEach(track => {
        track.stop();
        track.enabled = false;
      });
      localVideo.srcObject = null;
    }
    
    // Close stream via WebRTCAdaptor
    this.webRTCAdaptor && this.webRTCAdaptor.closeStream();
  }

  /**
   * Cleanup all streams and wait for cleanup to complete
   * Returns a Promise that resolves when all streams are closed
   */
  cleanupStreams() {
    return new Promise((resolve) => {
      // If no adaptor exists, resolve immediately
      if (!this.webRTCAdaptor) {
        resolve();
        return;
      }

      // Stop all remote video tracks
      if (this.streamsList && this.streamsList.length > 0) {
        this.streamsList.forEach((streamId) => {
          const video = document.getElementById("remoteVideo-" + streamId);
          if (video && video.srcObject) {
            video.srcObject.getTracks().forEach(track => {
              track.stop();
              track.enabled = false;
            });
            video.srcObject = null;
          }
          this.webRTCAdaptor && this.webRTCAdaptor.stop(streamId);
        });
        this.streamsList = [];
      }

      // Stop local video tracks
      const localVideo = document.getElementById("screenVideoANT");
      if (localVideo && localVideo.srcObject) {
        localVideo.srcObject.getTracks().forEach(track => {
          track.stop();
          track.enabled = false;
        });
        localVideo.srcObject = null;
      }

      // Leave room and close stream
      if (this.webRTCAdaptor) {
        this.webRTCAdaptor.leaveFromRoom(this.roomNameBox);
        this.webRTCAdaptor.closeStream();
        
        // Wait a bit for cleanup to complete, then resolve
        setTimeout(() => {
          this.state = states.NOT_IN_ROOM;
          resolve();
        }, 300);
      } else {
        resolve();
      }
    });
  }
}
